// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"703":"9b76bf5f3a92952ffa52","886":"7b568a8eb89900f67695","954":"bc1f9e5a6ffd9f4639f9"}[chunkId] + ".css";
};